import { render, staticRenderFns } from "./PostSwiper.vue?vue&type=template&id=4147def4&"
import script from "./PostSwiper.vue?vue&type=script&lang=ts&"
export * from "./PostSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./PostSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports